<div class="sidebar">
	<div class="loader_container__overlay" *ngIf="isLoading">
		<div class="loading-wrapper">
			<app-loading></app-loading>		
		</div>
	</div>
	<app-sidebar-header
		[title]="'createAccountSidebar.title.createAccount' | ibeadmin | async"
	></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" id="sidebar__body" #sidebar>
		<div class="sidebar--signup__image hidden-mobile">
			<img src="assets/images/banner_milesgo.svg" alt="Miles&GO banner image" />
		</div>
		<p>
			{{'createAccountSidebar.text.becomeFrequentFlyer' | ibeadmin | async}} <br><a class="link link--external" target="_blank"
				href="https://www.flytap.com/pt-pt/termos-e-condicoes-miles-and-go"
				[attr.aria-label]="'createAccountSidebar.aria.termsOfMilesGo' | ibeadmin | async" >{{'createAccountSidebar.text.learnMore' | ibeadmin | async}}</a>
		</p>
		<br>
		<app-notification (closeNotif)="INDRA_close($event)" *ngIf="showErrorMessage" [style]="'alert'" [icon]="'icons.svg#airport--delays'" [close]="true"
				[title]="'createAccountSidebar.title.itWasNotPossible' | ibeadmin | async">
				<div message *ngIf="showEmailError">
					<span>{{'createAccountSidebar.text.emailAlreadyLinked' | ibeadmin | async}}</span> <br />
				</div>
				<div message *ngIf="!showEmailError">
					<span>{{'createAccountSidebar.text.pleaseTryAgain' | ibeadmin | async}}</span> <br />
				</div>
		</app-notification>

		<hr class="separator" aria-hidden="true">
		<ng-container *ngIf="socialImported; else importSocial">
			<app-notification *ngIf="!importError" [style]="'success'" [icon]="'icons.svg#general--check'">
				<div message>
					<span>{{'createAccountSidebar.text.your' | ibeadmin | async}} {{socialImported}} {{'createAccountSidebar.text.accountDetailsImported' | ibeadmin | async}}</span>
				</div>
			</app-notification>
			<app-notification *ngIf="importError" [style]="'alert'" [icon]="'icons.svg#airport--delays'">
				<div message>
					<span>{{'createAccountSidebar.text.somethingWentWrong' | ibeadmin | async}}</span>
				</div>
			</app-notification>
			<div class="title-h2">{{'createAccountSidebar.text.insertYourDetails' | ibeadmin | async}}</div>
		</ng-container>
		<ng-template #importSocial>
			<div>
				<h2 class="title-h2">{{'createAccountSidebar.text.createAccountWithSocDetails' | ibeadmin | async}}</h2>
			</div>
			<div>
				<div class="login-content__social col-6 col-tp-6 col-p-12" (click)="TAP_handleSocialImport('google')" aria-label="Login with Google account">
					<app-svg svg="sprite.svg#color_icon--google_logo" ng-reflect-svg="sprite.svg#color_icon--google_logo"></app-svg>
					<p>Google</p>
				</div>
			</div>
			<div class="title-h2">{{'createAccountSidebar.text.insertYourDetails' | ibeadmin | async}} </div>
			<p class="muted">{{'createAccountSidebar.text.detailsMustMatch' | ibeadmin | async}}</p>
		</ng-template>

		<form class="sidebar__form"
			(ngSubmit)="INDRA_saveSidebar()"
			[formGroup]="formCreate">
			<!-- START Personal form -->
			<ng-container>
				<div class="form-field--row grid no-padding">
					<div class="form-field col-4 col-tp-4 col-p-12">
						<label class="label" for="sign-up--name-prefix">{{'createAccountSidebar.text.title' | ibeadmin | async}}</label>
						<app-select-input-indra
							selectId="selectTitle"
							placeholder="{{'createAccountSidebar.text.selectTitle' | ibeadmin | async}}"
							formControlName="name_prefix"
							id="sign-up--name-prefix"
							[errorClass]="formCreate.get('name_prefix').invalid && triedToSubmit ? 'has-error' : ''"
							[options]="titleOptions"
							selectLabel="{{'createAccountSidebar.text.selectTitle' | ibeadmin | async}}">
						</app-select-input-indra>
						<span aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="triedToSubmit && formCreate.controls['name_prefix'].invalid"
							[attr.aria-label]="INDRA_Errors(formCreate.controls['name_prefix'], 'createAccountSidebar.text.title' | ibeadmin | async)">
							{{ INDRA_Errors(formCreate.controls["name_prefix"], 'createAccountSidebar.text.title' | ibeadmin | async) }}
						</span>
					</div>
					<div class="form-field col-4 col-tp-4 col-p-12">
						<label class="label" for="first-name">{{'createAccountSidebar.text.firstName' | ibeadmin | async}}</label>
						<input
							class="input-text {{ INDRA_hasErrorsClasses(formCreate.controls['givenName']) }}"
							formControlName="givenName"
							id="first-name"/>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="triedToSubmit && formCreate.controls['givenName'].invalid">
							{{ INDRA_Errors(formCreate.controls["givenName"], 'createAccountSidebar.text.firstName' | ibeadmin | async) }}
						</span>
					</div>

					<div class="form-field col-4 col-tp-4 col-p-12">
						<label class="label" for="last-name">{{'createAccountSidebar.text.lastName' | ibeadmin | async}}</label>
						<input
							class="input-text {{ INDRA_hasErrorsClasses(formCreate.controls['surname']) }}"
							formControlName="surname"
							id="last-name" />
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="triedToSubmit && formCreate.controls['surname'].invalid">
							{{ INDRA_Errors(formCreate.controls["surname"], 'createAccountSidebar.text.lastName' | ibeadmin | async) }}
						</span>
						<span 
							aria-live="polite" 
							class="input-error" 
							role="alert"
							*ngIf="triedToSubmit && formCreate.hasError('maxNameCharReached') && isMobile">
							{{ INDRA_Errors('maxNameCharReached') | ibeadmin | async  }}
						</span>
					</div>
					
					<ng-container *ngIf="!isMobile && triedToSubmit && formCreate.hasError('maxNameCharReached')">
						<div class="form-field form-field--no-top col-2 col-tp-2 col-p-12"></div>
						<div class="form-field form-field--no-top col-12 col-tp-10 col-p-12">
							<span
								aria-live="polite"
								class="input-error"
								role="alert">
								{{ INDRA_Errors('maxNameCharReached') | ibeadmin | async  }}
							</span>
						</div>
					</ng-container>
				</div>
				<div class="form-field--row grid no-padding">
					<div class="form-field no-margin col-7 col-tp-12 col-p-12">
						<app-date-form-indra 
							uniqueId="dateOfBirth"
							label="{{'bookingDetails.label.dateOfBirth' | ibeadmin:'sync'}}"
							dayLabel="{{'bookingDetails.label.dayOfBirth' | ibeadmin:'sync'}}"
							monthLabel="{{'bookingDetails.label.monthOfBirth' | ibeadmin:'sync'}}"
							yearLabel="{{'bookingDetails.label.yearOfBirth' | ibeadmin:'sync'}}"
							formControlName="birthdate"
							(change)="INDRA_checkIfMinor()"
							[onlyPast]="true">
						</app-date-form-indra>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="formCreate.controls['birthdate'].invalid && triedToSubmit">
							{{ INDRA_Errors(formCreate.controls["birthdate"], 'createAccountSidebar.text.birthDate' | ibeadmin | async) }}
						</span>
					</div>

					<div class="form-field col-5 col-tp-6 col-p-12">
						<label class="label" for="sign-up--nationality">{{'createAccountSidebar.text.nationality' | ibeadmin | async}}</label>
						<app-select-input-indra
							selectId="selectNationality"
							placeholder="{{'bookingDetails.label.selectNationality' | ibeadmin:'sync'}}"
							formControlName="nationality"
							id="sign-up--nationality"
							[errorClass]="formCreate.get('nationality').invalid && triedToSubmit ? 'has-error' : ''"
							[options]="countryCodes"
							[optionsTranslated]="true"
							selectLabel="{{'bookingDetails.label.selectNationality' | ibeadmin:'sync'}}">
						</app-select-input-indra>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="formCreate.controls['nationality'].invalid && triedToSubmit"
							[attr.aria-label]="INDRA_Errors(formCreate.controls['nationality'], 'createAccountSidebar.text.nationality' | ibeadmin | async)">
							{{ INDRA_Errors(formCreate.controls["nationality"], 'createAccountSidebar.text.nationality' | ibeadmin | async) }}
						</span>
					</div>
				</div>
			</ng-container>
			<!-- END Personal form -->
			<hr class="separator" aria-hidden="true">
			<div>
				<h2 class="title-h2">{{'createAccountSidebar.text.accountDetails' | ibeadmin | async}}</h2>
				<p class="muted">
					{{'createAccountSidebar.text.makeSureInsertName' | ibeadmin | async}}
				</p>
			</div>

			<!-- START Account details form -->
			<ng-container>
				<div class="form-field--row grid no-padding">
					<div class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="eadd">{{'createAccountSidebar.text.email' | ibeadmin | async}}</label>
						<input
							class="input-text {{ INDRA_hasErrorsClasses(formCreate.controls['email']) }}"
							formControlName="email"
							id="eadd"
							name ="eadd"
							autocomplete="new-eadd"/>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="formCreate.controls['email'].invalid && triedToSubmit">
							{{ INDRA_Errors(formCreate.controls["email"], 'createAccountSidebar.text.email' | ibeadmin | async) }}
						</span>
					</div>
				</div>

				<div class="form-field--row grid no-padding">
					<div class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="password">{{'createAccountSidebar.text.password' | ibeadmin | async}}</label>
						<input
						class="input-text {{ INDRA_hasErrorsClasses(formCreate.controls['password']) }}"
							type="password"
							formControlName="password"
							id="password"
							name = "password"
							autocomplete="new-password"
							maxlength="32"
							/>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="INDRA_isInvalid('password') || (formCreate.controls['password'].invalid && triedToSubmit)">
							{{ INDRA_Errors(formCreate.controls["password"], 'createAccountSidebar.text.password' | ibeadmin | async) }}
						</span>
					</div>

					<div class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="repassword">{{'createAccountSidebar.text.confirmPassword' | ibeadmin | async}}</label>
						<input
							autocomplete="off"
							class="input-text {{ INDRA_hasErrorsClasses(formCreate.controls['repassword']) }}"
							type="password"
							formControlName="repassword"
							id="repassword"
							maxlength="32"/>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="INDRA_isInvalid('repassword') || (formCreate.controls['password'].invalid && triedToSubmit)">
							{{ INDRA_Errors(formCreate.controls["repassword"], 'createAccountSidebar.text.confirmPassword' | ibeadmin | async) }}
							</span>
					</div>
				</div>
			</ng-container>
			<!-- END Account details form -->
			<!-- START Contacts form -->
			<hr class="separator" aria-hidden="true">
			<ng-container>
				<div>
					<h2 class="title-h2">{{'createAccountSidebar.text.contacts' | ibeadmin | async}}</h2>
					<p class="muted">
						{{'createAccountSidebar.text.theseContactsWillBeUsed' | ibeadmin | async}}
					</p>
				</div>
				<div class="form-field--row grid no-padding">
					<div class="form-field col-3 col-tp-3 col-p-12">
						<label class="label" for="sign-up--phone-type">{{'createAccountSidebar.text.phoneType' | ibeadmin | async}}</label>
						<app-select-input-indra
							selectId="selectPhoneType"
							placeholder="{{'createAccountSidebar.text.selectType' | ibeadmin | async}}"
							formControlName="phone_type"
							id="sign-up--phone-type"
							[errorClass]="formCreate.get('phone_type').invalid && triedToSubmit ? 'has-error' : ''"
							[options]="typeOptions"
							selectLabel="{{'createAccountSidebar.text.selectType' | ibeadmin | async}}">
						</app-select-input-indra>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							[attr.aria-label]="'createAccountSidebar.aria.typeIsRequired' | ibeadmin | async"
							*ngIf="triedToSubmit && formCreate.controls['phone_type'].invalid">
							{{ INDRA_Errors(formCreate.controls["phone_type"], 'createAccountSidebar.text.phoneType' | ibeadmin | async) }}
						</span>
					</div>
					<div class="form-field col-4 col-tp-4 col-p-12">
						<label class="label" for="emergency-contact-phone-country">{{'createAccountSidebar.text.countryCode' | ibeadmin | async}}</label>
						<div class="select-wrapper">
							<select
								selectbox
								class="select {{ INDRA_hasErrorsClasses(formCreate.controls['phone_prefix']) }}"
								formControlName="phone_prefix"
								id="emergency-contact-phone-country"
								placeholder="Choose code">
								<option *ngFor="let option of countryCodesWithPrefix; trackBy: trackByFn"
									[value]="option.dial_code">
									{{ option.name + " " + option.dial_code }}
								</option>
							</select>
						</div>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="triedToSubmit && formCreate.controls['phone_prefix'].invalid">
							{{ INDRA_Errors(formCreate.controls["phone_prefix"], 'createAccountSidebar.text.phoneCountryCode' | ibeadmin | async) }}
						</span>
					</div>
					<div class="form-field col-5 col-tp-5 col-p-12">
						<label class="label" for="emergency-contact-phone-number">{{'createAccountSidebar.text.phoneNumber' | ibeadmin | async}}</label>
						<input
							inputmode="tel"
							id="emergency-contact-phone-number"
							class="input-text select {{ INDRA_hasErrorsClasses(formCreate.controls['phone_number']) }}"
							placeholder="{{'createAccountSidebar.text.insertPhoneNumber' | ibeadmin | async}}"
							formControlName="phone_number" 
							maxlength="20"/>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="triedToSubmit && formCreate.controls['phone_number'].invalid">
							{{ INDRA_Errors(formCreate.controls["phone_number"], 'createAccountSidebar.text.phoneNumber' | ibeadmin | async) }}
						</span>
					</div>
				</div>

				<div class="form-field--row grid no-padding">
					<div class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="sign-up--city">{{'createAccountSidebar.text.cityOfResidence' | ibeadmin | async}}</label>
						<input
							class="input-text {{ INDRA_hasErrorsClasses(formCreate.controls['city']) }}"
							maxlength="30"
							formControlName="city"
							id="sign-up--city"/>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="triedToSubmit && formCreate.controls['city'].invalid">
							{{ INDRA_Errors(formCreate.controls["city"], 'createAccountSidebar.text.cityOfResidence' | ibeadmin | async) }}
						</span>
					</div>

					<div class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="sign-up--country">{{'createAccountSidebar.text.countryOfResidence' | ibeadmin | async}}</label>
						<app-select-input-indra
							selectId="selectCountry"
							placeholder="{{'createAccountSidebar.text.selectCountry' | ibeadmin | async}}"
							formControlName="country"
							id="sign-up--country"
							[errorClass]="formCreate.get('country').invalid && triedToSubmit ? 'has-error' : ''"
							[options]="countryCodes"
							[optionsTranslated]="true"
							selectLabel="{{'createAccountSidebar.text.selectCountry' | ibeadmin | async}}"
							(selectionChanged)="INDRA_formChanges(formCreate.controls['country'].value)">
						</app-select-input-indra>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							[attr.aria-label]="INDRA_Errors(formCreate.controls['country'], 'createAccountSidebar.text.country' | ibeadmin | async)"
							*ngIf="formCreate.controls['country'].invalid && triedToSubmit">
							{{ INDRA_Errors(formCreate.controls["country"], 'createAccountSidebar.text.country' | ibeadmin | async) }}
						</span>
					</div>
					
					<div *ngIf="this.formCreate.controls['country'].value === 'BR'" class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="cpf">CPF</label>
						<input class="input-text {{INDRA_hasErrorsClasses(formCreate.controls['cpf'])}}" [placeholder]="'createAccountSidebar.text.insertCPF' | ibeadmin | async"
							appNumberOnlypattern="\d*" size="11" maxlength="11" formControlName="cpf" id="cpf" />
						<span aria-live="polite" class="input-error" role="alert"
						*ngIf="INDRA_isInvalid('cpf') || (formCreate.controls['cpf'].invalid && triedToSubmit) || showFieldError">{{ INDRA_Errors(formCreate.controls["cpf"], "CPF", true) }}</span>
					</div>
					<div *ngIf="this.formCreate.controls['country'].value === 'PT'" class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="nif">NIF</label>
						<input class="input-text {{INDRA_hasErrorsClasses(formCreate.controls['nif'])}}" [placeholder]="'createAccountSidebar.text.insertNIF' | ibeadmin | async"
							appNumberOnlypattern="\d*" size="9" maxlength="9" formControlName="nif" id="nif" />
						<span aria-live="polite" class="input-error" role="alert"
						*ngIf="INDRA_isInvalid('nif') || (formCreate.controls['nif'].invalid && triedToSubmit) || showFieldError">{{ INDRA_Errors(formCreate.controls["nif"], "NIF", true) }}</span>
					</div>
					<div
						*ngIf="showStateField"
						class="form-field col-4 col-tp-4 col-p-12">
						<label class="label" for="sign-up--state">{{'createAccountSidebar.text.stateOfResidence' | ibeadmin | async}}</label>
						<app-select-input-indra
							formControlName="state"
							id="sign-up--state"
							[options]="stateOptions"
							[optionsTranslated]="true"
							[errorClass]="INDRA_hasErrorsClasses(formCreate.get('state'))"
						></app-select-input-indra>
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="triedToSubmit && formCreate.controls['state'].invalid">{{INDRA_Errors(formCreate.controls["state"], 'createAccountSidebar.text.state' | ibeadmin | async)}}</span>
					</div>
					
					<div class="form-field col-6 col-tp-6 col-p-12" *ngIf="isMinor">
						<!-- E-mail address of the responsible adult-->
						<label class="label" for="eaddRespAdt">{{'createAccountSidebar.text.emailResponsibleAdult' | ibeadmin | async}}</label>
						<input
							class="input-text {{ INDRA_hasErrorsClasses(formCreate.controls['emailResponsibleAdult']) }}"
							formControlName="emailResponsibleAdult"
							id="eaddRespAdt"
							name ="eaddRespAdt"
							autocomplete="new-eadd"/>
						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="formCreate.controls['emailResponsibleAdult'].invalid && triedToSubmit">
							{{ INDRA_Errors(formCreate.controls["emailResponsibleAdult"], 'createAccountSidebar.text.email' | ibeadmin | async) }}
						</span>
					</div>
					
				</div>
			</ng-container>
			<!-- END Contacts form -->
			<hr class="separator" aria-hidden="true">
			<!-- START Communications form -->
			<ng-container>
				<div>
					<h2 class="title-h2">{{'createAccountSidebar.text.communications' | ibeadmin | async}}</h2>

					<div class="form-field--row grid no-padding">
						<div class="form-field col-12 col-tp-12 col-p-12">
							<app-checkbox-input
								[parentForm]="formCreate"
								[id]="'formCreateEmailFlyTap'"
								[formControlName]="'communication_flytap_email'"
								label="{{'createAccountSidebar.text.iWantToReceiveFlytapEmail' | ibeadmin | async}}"
							></app-checkbox-input>
						</div>

						<div class="form-field col-12 col-tp-12 col-p-12">
							<app-checkbox-input
								[parentForm]="formCreate"
								[id]="'formCreateSMS'"
								[formControlName]="'communication_flytap_sms'"
								label="{{'createAccountSidebar.text.iWantToReceiveFlytapSMS' | ibeadmin | async}}"
							></app-checkbox-input>
						</div>

						<div class="form-field col-12 col-tp-12 col-p-12">
							<app-checkbox-input
								[parentForm]="formCreate"
								[id]="'formCreateEmailMiles'"
								[formControlName]="'communication_milesego_email'"
								label="{{'createAccountSidebar.text.iWantToReceiveTAPMGEmail' | ibeadmin | async}}"
							></app-checkbox-input>
						</div>

						<div class="form-field col-12 col-tp-12 col-p-12">
							<app-checkbox-input
								[parentForm]="formCreate"
								[id]="'formCreateSMSMiles'"
								[formControlName]="'communication_milesego_sms'"
								label="{{'createAccountSidebar.text.iWantToReceiveTAPMGSMS' | ibeadmin | async}}"
							></app-checkbox-input>
						</div>
					</div>
				</div>
			</ng-container>
			<!-- END Communications form -->
			<hr class="separator" aria-hidden="true">
			<!-- START Treatment consent form -->
			<ng-container>
				<div>
					<h2 class="title-h2">{{'createAccountSidebar.text.dateTreatmentConsent' | ibeadmin | async}}</h2>

					<div class="form-field--row grid no-padding">
						<div class="col-12 col-tp-12 col-p-12 disclaimer">
							<p class="muted bottom-gap">
								{{'createAccountSidebar.text.ifYouConsent' | ibeadmin | async}}
							</p>
							<p class="muted bottom-gap top-gap">
								{{'createAccountSidebar.text.yourProfileWillBeCreated' | ibeadmin | async}}
							</p>
							<p class="muted bottom-gap top-gap">
								{{'createAccountSidebar.text.forMoreInfo' | ibeadmin | async}}
							</p>

							<p class="bottom-gap top-gap">
								{{'createAccountSidebar.text.iAcceptTheTreatment' | ibeadmin | async}}
							</p>

							<div class="form-field col-5 col-tp-5 col-p-12">
								<app-radio-input-group-indra 
									role="radiogroup" 
									aria-labelledby="cardholder_will_travel-label" 
									class="inline"
									formControlName="treatment_consent" 
									name="treatment_consent"
									(optionChanged)="INDRA_changedTreatmentConsent($event)"
									[options]="treatmentConsentOptions">
								</app-radio-input-group-indra>
							</div>
							<span
								aria-live="polite"
								class="input-error"
								role="alert"
								*ngIf="formCreate.controls['treatment_consent'].invalid && triedToSubmit">
								{{ INDRA_Errors(formCreate.controls["treatment_consent"], 'createAccountSidebar.text.dateTreatmentConsent' | ibeadmin | async) }}
							</span>
						</div>
					</div>
				</div>
			</ng-container>
			<!-- END Treatment consent form -->

			<!-- START TAP Miles&Go Programme's form -->
			<ng-container>
				<div class="form-field--row grid no-padding terms">
					<div class="form-field col-12 col-tp-12 col-p-12">
						<app-checkbox-input
							[parentForm]="formCreate"
							[id]="'formCreate'"
							[formControlName]="'terms_conditions'"
							label="{{'createAccountSidebar.text.iHaveReadAndAccept' | ibeadmin | async}}">
						</app-checkbox-input>

						<span
							aria-live="polite"
							class="input-error"
							role="alert"
							*ngIf="formCreate.controls['terms_conditions'].invalid && triedToSubmit">
							{{ INDRA_Errors(formCreate.controls["terms_conditions"], 'createAccountSidebar.text.termsAndCondition' | ibeadmin | async) }}
						</span>
					</div>
				</div>
			</ng-container>
			<!-- END TAP Miles&Go Programme's form -->

			<!-- <button class="button full-width" type="submit">Sign up for TAP Miles&Go</button> -->
			<div class="form-field--row no-padding" id="boxButtons">
				<button class="button side-button full-width"
					type="submit"
					[disabled]="formCreate.controls['terms_conditions'].invalid || formCreate.controls['terms_conditions'].value === false">
					{{'createAccountSidebar.text.signUpForTAPMG' | ibeadmin | async}}
				</button>
				<button
					class="link side-button full-width top-gap"
					(click)="INDRA_withoutDiscount()"
					[attr.aria-label]="'createAccountSidebar.aria.closeDialog' | ibeadmin | async" >
					{{'createAccountSidebar.text.cancel' | ibeadmin | async}}
				</button>
				
			</div>
		</form>
	</div>
</div>
